import { ConfigFn } from '@config/types'

const config = (({ publication, weatherUrl }) =>
  ({
    domain: `${weatherUrl}`,
    baseUrl: `${weatherUrl}/weather/v1/`,
    fetchExpirationTime: 30,
    meteoNewsUrl:
      publication === 'romandie'
        ? 'https://meteonews.ch/fr/Carte_meteo/CCH/Suisse'
        : 'https://meteonews.ch/de/Redirect/blick/',
  }) as const) satisfies ConfigFn

export default config
